import gsap from "gsap/all";

export default () => ({
    isOpenLevel1: false,
    isOpenLevel2: false,
    tweenProps: {
        duration: 0.3,
    },

    init() {
      this.checkActiveState();
    },

    checkActiveState() {
      try {
        const homeLink = document.querySelector('a[x-data="logo"]').getAttribute('href');

        this.$refs.mobileMenu.querySelectorAll('.current, .active').forEach((item) => {
          item.parentNode.classList.remove('current', 'active');
        });

        let pathname = document.location.pathname;

        // product shareclass links..
        let shareclassLink = document.querySelector('.product-tags a');
        if (shareclassLink) {
          if (document.querySelector('.product-tags a[href^="' + pathname + '"]')) {
            pathname = shareclassLink.getAttribute('href').split('#')[0];
          }
        }

        // normal nav links..
        this.$refs.mobileMenu.querySelectorAll('a[href="' + pathname + '"]').forEach((item) => {
          if (item.getAttribute('href') === homeLink) {
            return;
          }

          if (!item.getAttribute('x-on:click')) {
            item.closest('li').classList.add('current');
          }

          const level0Item = item.closest('li.level-0-item');
          if (level0Item) {
            level0Item.classList.add('active');
          }

          const level1Item = item.closest('li.level-1-item');
          if (level1Item) {
            level1Item.classList.add('active');
          }

          const level2Item = item.closest('li.level-2-item');
          if (level2Item) {
            level2Item.classList.add('active');
          }
        });
      } catch (e) {
        console.log(e);
      }
    },

    toggleLevel1(el) {
        this.isOpenLevel1 = !this.isOpenLevel1;

        if (this.isOpenLevel1) {
            return this.open(el);
        }

        this.close(el);
    },

    toggleLevel1byLink(ev) {
        ev.preventDefault();
        ev.target.nextElementSibling.dispatchEvent(new Event("click"));
    },

    toggleLevel2(el) {
        this.isOpenLevel2 = !this.isOpenLevel2;

        if (this.isOpenLevel2) {
            this.open(el, ".level-2");
            this.open(el, ".level-3");
            return;
        }

        this.close(el, ".level-2");
        this.close(el, ".level-3");
    },

    /**
     * Open accordion
     *
     * @param el
     * @param level
     * @returns {gsap.core.Timeline}
     */
    open(el, level = ".level-1") {
        const btn = el.target;
        const item = btn.parentNode.parentNode;
        const menu = item.querySelectorAll(level);
        const siblings = this.getSiblingsOf(item);

        // add state class
        item.classList.add("open");

        // close the current accordion
        this.hide(siblings);

        let tl = gsap
            .timeline()
            .to(".mobile-footer", {
                yPercent: 100,
            })
            .to(
                menu,
                {
                    height: "auto",
                    opacity: 1,
                    ...this.tweenProps,
                },
                0
            );

        if (level === ".level-1") {
            return tl.add(
                gsap.to(btn, {
                    rotation: -45,
                    transformOrigin: "center",
                    ...this.tweenProps,
                }),
                0
            );
        }

        if (level === ".level-2") {
            return tl.add(
                gsap.to(this.getElementToRotate(btn), {
                    rotation: -180,
                    transformOrigin: "center",
                    ...this.tweenProps,
                }),
                0
            );
        }
    },

    /**
     * Close accordion
     *
     * @param el
     * @param level
     */
    close(el, level = ".level-1") {
        const btn = el.target;
        const item = btn.parentNode.parentNode;
        const menu = item.querySelector(level);
        const siblings = this.getSiblingsOf(item);

        // remove state class
        item.classList.remove("open");

        // show all siblings again
        this.show(siblings);

        gsap.timeline()
            .to(".mobile-footer", {
                yPercent: 0,
                ease: "back.out(1)",
                ...this.tweenProps,
            })
            .to(
                this.getElementToRotate(btn),
                {
                    rotation: 0,
                    ...this.tweenProps,
                },
                0
            )
            .to(
                menu,
                {
                    height: 0,
                    opacity: 0,
                    ...this.tweenProps,
                },
                0
            );
    },

    /**
     * Show sibling accordions
     *
     * @param siblings
     */
    show(siblings) {
        gsap.to(siblings, {
            height: "auto",
            ...this.tweenProps,
        });
    },

    /**
     * Hide sibling accordions
     *
     * @param siblings
     */
    hide(siblings) {
        gsap.to(siblings, {
            height: 0,
            ...this.tweenProps,
        });
    },

    getElementToRotate(btn) {
        const tagName = btn.tagName.toLowerCase();
        return tagName === "button" ? btn : btn.nextElementSibling;
    },

    /**
     * Get siblings of a given element
     *
     * @param e
     * @returns {*[]}
     */
    getSiblingsOf(e) {
        // for collecting siblings
        let siblings = [];
        // if no parent, return no sibling
        if (!e.parentNode) {
            return siblings;
        }
        // first child of the parent node
        let sibling = e.parentNode.firstChild;

        // collecting siblings
        while (sibling) {
            if (sibling.nodeType === 1 && sibling !== e) {
                siblings.push(sibling);
            }
            sibling = sibling.nextSibling;
        }
        return siblings;
    },
});
